function hasFirmware(firmware) {
  return firmware != null && firmware !== '---';
}

export function CompareWifiFirmware(installed, availible, cont_type) {
  if (cont_type === 5055) {
    installed = installed.replace('515', '505');
  }
  if (installed === undefined || availible === undefined) {
    return false;
  }
  if (availible.indexOf('.bin') === -1) {
    return false;
  }
  installed = installed.replaceAll('.', '');
  availible = availible.substring(2, availible.indexOf('.bin'));
  console.log(
    '[fws] version cmp (ESP): ',
    cont_type,
    installed,
    availible,
    '=>',
    installed.localeCompare(availible)
  );
  return installed.localeCompare(availible);
}

export function CompareWifiFirmwares(controller, firmware_versions) {
  console.log('[fw] Cmp ESP firmwares: ', firmware_versions);
  const cont_esp_fw = controller?.settings?.system?.esp32_firmware_name;
  if (cont_esp_fw === undefined) {
    return false;
  }
  for (const fw of firmware_versions[controller?.type]) {
    if (fw.esp_firmware === undefined || fw.hide_banner) {
      continue;
    }
    if (CompareWifiFirmware(cont_esp_fw, fw.esp_firmware, controller.type) < 0) {
      return true;
    }
  }
  return false;
}

export function CompareGCFirmware(installed, availible) {
  if (installed === undefined || availible === undefined) {
    return false;
  }
  if (availible.indexOf('.bin') === -1) {
    return false;
  }
  installed = installed.replaceAll('.', '');
  availible = availible.substring(2, availible.indexOf('.bin'));
  console.log(
    '[fw] version cmp (GC): ',
    installed,
    availible,
    '=>',
    installed.localeCompare(availible)
  );
  return installed.localeCompare(availible);
}

export function CompareGCFirmwares(controller, firmware_versions) {
  console.log('[fw] Cmp GC firmwares: ', firmware_versions);
  const cont_gc_fw = controller?.settings?.system?.fw_version_number;
  if (cont_gc_fw === undefined) {
    return false;
  }
  for (const fw of firmware_versions[controller?.type]) {
    if (fw.gc_firmware === undefined || fw.hide_banner) {
      continue;
    }
    if (CompareGCFirmware(cont_gc_fw, fw.gc_firmware) < 0) {
      return true;
    }
  }
  return false;
}

export function GetFirmwareUpdateComponents(
  installedGcFirmware,
  installedEspFirmware,
  version,
  controllerType
) {

  const allowDowngrade = version != null && 'allow_downgrade' in version;
  const gcAvailable = hasFirmware(version?.gc_firmware);
  const espAvailable = hasFirmware(version?.esp_firmware);

  const gcComparison =
    gcAvailable && installedGcFirmware
      ? CompareGCFirmware(installedGcFirmware, version.gc_firmware)
      : null;
  const espComparison =
    espAvailable && installedEspFirmware
      ? CompareWifiFirmware(installedEspFirmware, version.esp_firmware, controllerType)
      : null;

  return {
    gc: gcAvailable && (allowDowngrade || gcComparison < 0),
    esp: espAvailable && (allowDowngrade || espComparison < 0)
  };
}

export function IsFirmwareVersionSelectable(
  installedGcFirmware,
  installedEspFirmware,
  version,
  controllerType
) {
	// implement update restrictions here for Industrial Pro
	if (controllerType === 6000) return true;

  if (!installedGcFirmware || !installedEspFirmware) {
    return true;
  }

  const espRequirementMet =
    !('requires_esp' in version) ||
    CompareWifiFirmware(installedEspFirmware, version.requires_esp, controllerType) >= 0;
  const gcRequirementMet =
    !('requires_gc' in version) || CompareGCFirmware(installedGcFirmware, version.requires_gc) >= 0;

  if (!espRequirementMet || !gcRequirementMet) {
    return false;
  }

  if ('allow_downgrade' in version) {
    return true;
  }

  const gcAvailable = hasFirmware(version.gc_firmware);
  const espAvailable = hasFirmware(version.esp_firmware);
  const gcComparison = gcAvailable
    ? CompareGCFirmware(installedGcFirmware, version.gc_firmware)
    : null;
  const espComparison = espAvailable
    ? CompareWifiFirmware(installedEspFirmware, version.esp_firmware, controllerType)
    : null;

  const noComponentWouldDowngrade =
    (!gcAvailable || gcComparison <= 0) && (!espAvailable || espComparison <= 0);
  const atLeastOneComponentNeedsUpdate =
    (gcAvailable && gcComparison < 0) || (espAvailable && espComparison < 0);

  return noComponentWouldDowngrade && atLeastOneComponentNeedsUpdate;
}
